[
  {
    "hash": "1ca33979810f77d0a805ade7e801920a5833259599518a5355f4cb5e7911fb4d",
    "commit": "a7ee2dbcde0c023a1ddbf42742c16d4e54efd5e8",
    "clean": false,
    "project": "hack.near/private-investigator",
    "released_at": "2026-10-05T13:17:00Z",
    "note": "Released from uncommitted changes on this commit, before releases were recorded; not reproducible from any commit."
  },
  {
    "hash": "202fd920a126736025a1ccc7b50cb687c1f89ff182a4a242809f8d09403bfaf3",
    "commit": "524a6b7160ae4f52ac786527d303f4f8d62d9342",
    "clean": false,
    "project": "hack.near/private-investigator",
    "released_at": "2026-10-05T16:28:13.482Z",
    "note": "Built from this commit natively on macOS (aarch64): it rebuilds only on that host, since the same source builds different bytes on different hosts. Releases from then on build in app/build.sh's pinned container."
  },
  {
    "hash": "4774ae74e3a7c8edbe3ef8c5ac519bbc4889c396d2987af3e5ba494f26bc4bce",
    "commit": "b861419394e3a12f08034254e77e57fbed8f8ed1",
    "clean": true,
    "project": "hack.near/private-investigator",
    "released_at": "2026-10-05T18:51:30.453Z"
  },
  {
    "hash": "0ded2df537606fcd8f79f6a4dec4e3a713097d2260ef1c81d099c61e4fac7a99",
    "commit": "5ba4b4be4823b37b5d383b511cd30a0cf752e2a8",
    "clean": true,
    "project": "hack.near/private-investigator",
    "recorded_at": "2026-10-06T01:01:31.037Z"
  },
  {
    "hash": "be48cd26c679ef2a24e9ff4cc123f5acc9deb4e8ce8ff823862e0345402dfde3",
    "commit": "b5942b7aa3fa3c9f3f39d5380356dce7b6db4935",
    "clean": true,
    "project": "hack.near/private-investigator",
    "recorded_at": "2026-10-06T03:07:32.893Z"
  },
  {
    "hash": "57694908daa31bcae6b9388abb00d360c1264179774e1db02ae8074223873a3e",
    "commit": "88e4f47d2694b8f58e0a9bce61705b6a6725e643",
    "clean": true,
    "project": "hack.near/private-investigator",
    "recorded_at": "2026-10-06T23:35:27.238Z"
  },
  {
    "hash": "760579d851712ff20569d19c2d01182070d6d1577824a61475dcad97f2178740",
    "commit": "e971acd3666bab7216fab6ae2435b4748e39cb69",
    "clean": true,
    "project": "hack.near/private-investigator",
    "recorded_at": "2026-10-07T00:50:55.486Z"
  },
  {
    "hash": "0b2f0197b46ceada5d4b2d560dad042c46ac60b0275ac36a2edf7b39387cdd72",
    "commit": "cab44c9cec872006799d0ed1232f8037a3d13667",
    "clean": true,
    "project": "hack.near/private-investigator",
    "recorded_at": "2026-10-07T01:23:58.551Z"
  },
  {
    "hash": "68f685542ee203d5ef4f7f98d89750f6afdc06ef77e1fbfdc7cae0a3febba4ae",
    "commit": "e305f08cec743b2f7019967fca71ecd28bf36ba9",
    "clean": true,
    "project": "hack.near/private-investigator",
    "recorded_at": "2026-10-15T18:24:15.086Z"
  }
]
